export const URI_USER = "/api/user";
export const URI_USER_ADD = "/api/user";
export const URI_USER_DELETE = "/api/user/:id";
export const URI_USER_EDIT = "/api/user/:id";
export const URI_USER_FORM = "/api/user/:id/form";
